// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"806":"user","884":"admin","993":"leerstand"}[chunkId] || chunkId) + "." + {"503":"7d28b10d","806":"0c75a332","884":"53bddd28","993":"659d86bb"}[chunkId] + ".css";
};